import React from 'react';
import PropTypes from 'prop-types';
import './_MatchDetailPlayersLegend.scss';

const buildColumns = (items, size) => {
  const columns = [];

  for (let index = 0; index < items.length; index += size) {
    columns.push(items.slice(index, index + size));
  }

  return columns;
};

const MatchDetailPlayersLegend = ({ items }) => {
  const columns = buildColumns(items, 4);

  return (
    <div className="match-detail-players-legend">
      <div className="match-detail-players-legend__row">
        {columns.map((column, columnIndex) => (
          <div key={`players-legend-col-${columnIndex}`} className="match-detail-players-legend__cell">
            {column.map((item, itemIndex) => (
              <p key={`players-legend-item-${columnIndex}-${item.key}-${itemIndex}`} className="match-detail-players-legend__item">
                <span className="match-detail-players-legend__key">{item.key}:</span>{item.label}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

MatchDetailPlayersLegend.propTypes = {
  items: PropTypes.array
};

MatchDetailPlayersLegend.defaultProps = {
  items: []
};

export default MatchDetailPlayersLegend;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailPlayersLegend/MatchDetailPlayersLegend.jsx